<template>
  <div class="advanced-reports">
    <div class="filters">
      <div class="filter-group">
        <label>From Date</label>
        <input
            type="datetime-local"
            v-model="filters.fromDate"
            :max="filters.toDate"
        />
      </div>

      <div class="filter-group">
        <label>To Date</label>
        <input
            type="datetime-local"
            v-model="filters.toDate"
            :min="filters.fromDate"
        />
      </div>

      <button @click="fetchGameActions" :disabled="loading">
        {{ loading ? 'Загрузка...' : 'Применить' }}
      </button>
      <button @click="resetFilters">Сбросить</button>
    </div>

    <div v-if="error" class="error-message">
      {{ error }}
    </div>

    <div v-if="gameActions.length > 0" class="results">
      <table class="game-actions-table">
        <thead>
        <tr>
          <th>ID</th>
          <th>Дата</th>
          <th>Тип</th>
          <th>Валюта</th>
          <th>Сумма</th>
          <th>Баланс</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="action in gameActions" :key="action.id">
          <td>{{ action.id }}</td>
          <td>{{ formatDate(action.timestamp) }}</td>
          <td>{{ action.type }}</td>
          <td>{{ action.currency }}</td>
          <td>{{ action.creditAmount || action.debitAmount }}</td>
          <td>{{ action.balance }}</td>
        </tr>
        </tbody>
      </table>
      <div class="total-count">Всего записей: {{ totalCount }}</div>
    </div>
    <div v-else-if="!loading" class="no-results">
      Нет данных для отображения
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdvancedReports',
  data() {
    return {
      filters: {
        fromDate: this.getDefaultFromDate(),
        toDate: this.formatDate(new Date())
      },
      gameActions: [],
      totalCount: 0,
      loading: false,
      error: null
    }
  },
  methods: {
    getDefaultFromDate() {
      const date = new Date();
      date.setDate(date.getDate() - 7); // 7 дней назад по умолчанию
      return this.formatDate(date);
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const pad = num => (num < 10 ? '0' + num : num);
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    formatDisplayDate(dateString) {
      return new Date(dateString).toLocaleString();
    },

    async fetchGameActions() {
      this.loading = true;
      this.error = null;

      try {
        const params = new URLSearchParams({
          from: new Date(this.filters.fromDate).toISOString(),
          to: new Date(this.filters.toDate).toISOString(),
          orderBy: 'timestamp',
          direction: 'DESC'
        });

        const response = await fetch(`/api/game-actions/advanced-report?${params}`, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'include'
        });

        // Проверка типа содержимого
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          const errorText = await response.text();
          throw new Error(`Сервер вернул HTML вместо JSON: ${errorText.substring(0, 100)}`);
        }

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || `Ошибка сервера: ${response.status}`);
        }

        if (data.success) {
          this.gameActions = data.data;
          this.totalCount = data.total;
        } else {
          throw new Error(data.message || 'Неизвестная ошибка при обработке данных');
        }
      } catch (err) {
        console.error('Ошибка запроса:', err);
        this.error = err.message || 'Произошла ошибка при загрузке данных';
        this.gameActions = [];
        this.totalCount = 0;
      } finally {
        this.loading = false;
      }
    },

    resetFilters() {
      this.filters = {
        fromDate: this.getDefaultFromDate(),
        toDate: this.formatDate(new Date())
      };
      this.gameActions = [];
      this.totalCount = 0;
      this.error = null;
    }
  }
}
</script>

<style scoped>
.advanced-reports {
  font-family: Arial, sans-serif;
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: flex-end;
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f5f5;
  border-radius: 5px;
}

.filter-group {
  display: flex;
  flex-direction: column;
}

label {
  margin-bottom: 5px;
  font-weight: bold;
}

input {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

button {
  padding: 8px 15px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  height: fit-content;
}

button:hover {
  background-color: #45a049;
}
</style>